export const redirectToWithLoader = (url) => {
  $.don_loader_start();
  location.href = url;
  setTimeout(() => {
    $.don_loader_end();
  }, 5000);
};
